const latexFormula = "_uxsl1ftcit3";

export { latexFormula };
import "./spec.image.comp.style.linaria.module.css";
//# sourceMappingURL=spec.image.comp.style.js.map
